import { supabase } from '../lib/supabase';

export interface FAQItem {
  id: string;
  question: string;
  answer: string;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

interface FAQResponse {
  data: FAQItem[] | null;
  error: Error | null;
}

export const faqService = {
  async getAll(): Promise<FAQResponse> {
    try {
      const { data, error } = await supabase
        .from('faq_items')
        .select('*')
        .order('display_order', { ascending: true });

      if (error) throw error;

      // Convert snake_case to camelCase
      const faqItems = (data || []).map(item => ({
        id: item.id,
        question: item.question,
        answer: item.answer,
        displayOrder: item.display_order,
        createdAt: item.created_at,
        updatedAt: item.updated_at
      }));

      return { data: faqItems, error: null };
    } catch (error) {
      return { 
        data: null, 
        error: error instanceof Error ? error : new Error('Failed to fetch FAQs')
      };
    }
  }
};